/**
 * TAB CONTENT
 * Contenu d'onglet réutilisable avec titre, recherche et table
 */

import { SearchInput } from '../ui/SearchInput';

interface TabContentProps {
  title: string;
  count: number;
  searchValue: string;
  searchPlaceholder: string;
  onSearchChange: (value: string) => void;
  isEmpty: boolean;
  emptyMessage: string;
  emptySearchMessage: string;
  children: React.ReactNode;
}

export function TabContent({
  title,
  count,
  searchValue,
  searchPlaceholder,
  onSearchChange,
  isEmpty,
  emptyMessage,
  emptySearchMessage,
  children,
}: TabContentProps) {
  const displayEmptyMessage = searchValue ? emptySearchMessage : emptyMessage;

  return (
    <div className="flex flex-col gap-4">
      {/* Header avec titre et recherche */}
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-zinc-900">
          {title} ({count})
        </h3>
        <SearchInput
          value={searchValue}
          onChange={onSearchChange}
          placeholder={searchPlaceholder}
        />
      </div>

      {/* Contenu ou message vide */}
      {isEmpty ? (
        <div className="flex items-center justify-center py-12 text-sm text-zinc-500">
          {displayEmptyMessage}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
